export default "__VITE_ASSET__7d2dd34a__"